import { createLocaleText, getLocale, setLocale, useLocaleText } from '@meitu/xdesign-i18n';
import { localeTextMap, type LocaleCode, type LocaleText } from '../locales';

type LocaleStoreCache = Record<
    LocaleCode,
    {
        locale: LocaleCode;
        $t: ReturnType<typeof createLocaleText<LocaleText>>;
    }
>;
const localStoreCache: Partial<LocaleStoreCache> = {};

export const initLocaleStore = (locale: LocaleCode) => {
    setLocale(locale);
};

export const getLocaleStore = (_locale?: LocaleCode) => {
    const locale: LocaleCode = _locale || getLocale() || 'cn';
    const localeText = localeTextMap[locale];

    if (!localStoreCache[locale]) {
        localStoreCache[locale] = {
            locale,
            $t: createLocaleText(localeText),
        };
    }

    return localStoreCache[locale]!;
};

export const useLocaleStore = () => {
    const locale = useLocaleText<LocaleCode>();

    return getLocaleStore(locale);
};
